import moment from 'moment';
import { EMARPOLDocuments } from '../../marpol/@types';
import {
    EAnnex6V2RecordCode,
    EAnnex6V2RecordState,
    TAnnex6V2CommonData,
    TAnnex6V2CommonFields,
} from '../@types';

export type TAnnex6V2ItemA1P1 = {
    systemIdentification: string;
    typeOfODS: string;
    initialChargeOfSystem: number;
};
export type TAnnex6V2ItemA1P2 = {
    date: string;
    time: string;
};

export type TAnnex6V2ItemA1P3 = {
    activity: string;
};

export type TAnnex6V2ItemA1P4 = {
    chargeAdded: number;
    chargeRemoved: number;
    finalCharge: number;
};

const odsEquipmentActivities = [
    {
        label: 'Recharge (full or Partial)',
        value: 'Recharge (full or Partial)',
    },
    {
        label: 'Repair or Maintenance',
        value: 'Repair or Maintenance',
    },
    {
        label: 'Deliberate discharge to Atmosphere',
        value: 'Deliberate discharge to Atmosphere',
    },
    {
        label: 'Non-deliberate discharge to atmosphere',
        value: 'Non-deliberate discharge to atmosphere',
    },
    {
        label: 'Discharge to land-based facility',
        value: 'Discharge to land-based facility',
    },
    {
        label: 'Supply of ODS to Ship',
        value: 'Supply of ODS to Ship',
    },
];

const odsEquipmentActivitiesCodes = [
    {
        value: 'Recharge (full or Partial)',
        code: '3.1',
    },
    {
        value: 'Repair or Maintenance',
        code: '3.2',
    },
    {
        value: 'Deliberate discharge to Atmosphere',
        code: '3.3',
    },
    {
        value: 'Non-deliberate discharge to atmosphere',
        code: '3.4',
    },
    {
        value: 'Discharge to land-based facility',
        code: '3.5',
    },
    {
        value: 'Supply of ODS to Ship',
        code: '3.6',
    },
];

export type TAnnex6V2GroupA1 = TAnnex6V2CommonFields &
    TAnnex6V2CommonData & {
        id: string;
        recordCode: EAnnex6V2RecordCode.Annex6V2A1;
        itemA1P1: TAnnex6V2ItemA1P1;
        itemA1P2: TAnnex6V2ItemA1P2;
        itemA1P3: TAnnex6V2ItemA1P3;
        itemA1P4: TAnnex6V2ItemA1P4;
    };

export type TAnnex6V2GroupA = TAnnex6V2GroupA1;

const Annex6V2_GROUPA_DEFAULTS: {
    GROUPA1: TAnnex6V2GroupA1;
} = {
    GROUPA1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.ANNEX6V2,
        state: EAnnex6V2RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        timeZone: '',
        remarks: '',
        itemA1P1: {
            systemIdentification: '',
            typeOfODS: '',
            initialChargeOfSystem: 0,
        },
        itemA1P2: {
            date: moment().format('YYYY-MM-DD'),
            time: moment().format('HH:mm'),
        },
        itemA1P3: {
            activity: '',
        },
        itemA1P4: {
            chargeAdded: 0,
            chargeRemoved: 0,
            finalCharge: 0,
        },
        recordCode: EAnnex6V2RecordCode.Annex6V2A1,
    },
};

export {
    Annex6V2_GROUPA_DEFAULTS,
    odsEquipmentActivities,
    odsEquipmentActivitiesCodes,
};
